/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気開通受付情報
 */
export interface Sgkb575aResElecProvisionacceptanceInfo {
    /** 
     * 更新フラグ：半角英数混在
     */
    koshinFlg?: string;
    /** 
     * 更新フラグ名称：全角半角混在
     */
    koshinFlgMeisho?: string;
    /** 
     * 電力会社エリア：半角数字
     */
    denryokugaishaArea?: string;
    /** 
     * 電力会社エリア名称：全角半角混在
     */
    denryokugaishaAreaMeisho?: string;
    /** 
     * 申込種別：半角英数混在
     */
    srnClsfy?: string;
    /** 
     * 申込種別名称：全角半角混在
     */
    srnClsfyAname?: string;
    /** 
     * 申込番号：半角数字
     */
    moshikomiNo?: string;
    /** 
     * 小売事業者申込番号：半角数字
     */
    koriMoshikomiNo?: string;
    /** 
     * 小売事業者コード：半角英数混在
     */
    genKeiyakuKoriCd?: string;
    /** 
     * 小売事業者名称：全角半角混在
     */
    koriMeisho?: string;
    /** 
     * 要求成否ステータス：半角英数混在
     */
    yokyuSeihiStatus?: string;
    /** 
     * 要求成否ステータス名称：全角半角混在
     */
    yokyuSeihiStatusMeisho?: string;
    /** 
     * 受付工程：半角英数混在
     */
    uketsukeKotei?: string;
    /** 
     * 受付工程名称：全角半角混在
     */
    uketsukeKoteiMeisho?: string;
    /** 
     * 受付工程更新日時：日付YYYYMMDD
     */
    uketsukeKoteiKoshinTimestamp?: string;
    /** 
     * 受付メッセージ（１）（区分）：半角英数混在
     */
    uketsukemessage1Div?: string;
    /** 
     * 受付メッセージ（１）（区分）名称：全角半角混在
     */
    uketsukemessage1Divaname?: string;
    /** 
     * 受付メッセージ（２）（区分）：半角英数混在
     */
    uketsukemessage2Div?: string;
    /** 
     * 受付メッセージ（２）（区分）名称：全角半角混在
     */
    uketsukemessage2Divaname?: string;
    /** 
     * 受付メッセージ（３）（区分）：半角英数混在
     */
    uketsukemessage3Div?: string;
    /** 
     * 受付メッセージ（３）（区分）名称：全角半角混在
     */
    uketsukemessage3Divaname?: string;
    /** 
     * 受付メッセージ（４）（区分）：半角英数混在
     */
    uketsukemessage4Div?: string;
    /** 
     * 受付メッセージ（４）（区分）名称：全角半角混在
     */
    uketsukemessage4Divaname?: string;
    /** 
     * 受付メッセージ（５）（区分）：半角英数混在
     */
    uketsukemessage5Div?: string;
    /** 
     * 受付メッセージ（５）（区分）名称：全角半角混在
     */
    uketsukemessage5Divaname?: string;
    /** 
     * 受付メッセージ（６）（区分）：半角英数混在
     */
    uketsukemessage6Div?: string;
    /** 
     * 受付メッセージ（６）（区分）名称：全角半角混在
     */
    uketsukemessage6Divaname?: string;
    /** 
     * 受付メッセージ（７）（区分）：半角英数混在
     */
    uketsukemessage7Div?: string;
    /** 
     * 受付メッセージ（７）（区分）名称：全角半角混在
     */
    uketsukemessage7Divaname?: string;
    /** 
     * 受付メッセージ（８）（区分）：半角英数混在
     */
    uketsukemessage8Div?: string;
    /** 
     * 受付メッセージ（８）（区分）名称：全角半角混在
     */
    uketsukemessage8Divaname?: string;
    /** 
     * 受付メッセージ（９）（区分）：半角英数混在
     */
    uketsukemessage9Div?: string;
    /** 
     * 受付メッセージ（９）（区分）名称：全角半角混在
     */
    uketsukemessage9Divaname?: string;
    /** 
     * 受付メッセージ（１０）（区分）：半角英数混在
     */
    uketsukemessage10Div?: string;
    /** 
     * 受付メッセージ（１０）（区分）名称：全角半角混在
     */
    uketsukemessage10Divaname?: string;
    /** 
     * ご連絡事項：全角半角混在
     */
    renrakuJiko?: string;
    /** 
     * 接続送電サービスメニュー：半角英数混在
     */
    setsuzokuSodenServiceMenu?: string;
    /** 
     * 接続送電サービスメニューコード名称：全角半角混在
     */
    transMnucodAname?: string;
    /** 
     * 契約決定方法：半角英数混在
     */
    keiyakuKetteiHoho?: string;
    /** 
     * 契約決定方法名称：全角半角混在
     */
    keiyakuKetteiHohoMeisho?: string;
    /** 
     * 需要者氏名（カナ）：半角カナ
     */
    juyoshaShimeiKana?: string;
    /** 
     * 需要者氏名（漢字）：全角文字
     */
    juyoshaShimeiKanji?: string;
    /** 
     * 需要者電話番号（１）（区分）：半角英数混在
     */
    juyoshaTel1Kbn?: string;
    /** 
     * 需要者電話番号（１）（区分）名称：全角半角混在
     */
    juyoshaTel1KbnMeisho?: string;
    /** 
     * 需要者電話番号（１）：電話番号(ハイフンと数値含む)
     */
    juyoshaTel1?: string;
    /** 
     * 需要者電話番号（２）（区分）：半角英数混在
     */
    juyoshaTel2Kbn?: string;
    /** 
     * 需要者電話番号（２）（区分）名称：全角半角混在
     */
    juyoshaTel2KbnMeisho?: string;
    /** 
     * 需要者電話番号（２）：電話番号(ハイフンと数値含む)
     */
    juyoshaTel2?: string;
    /** 
     * 廃止取次番号：半角数字
     */
    ablcomNo?: string;
    /** 
     * 現小売事業者コード：半角英数混在
     */
    oldretCode?: string;
    /** 
     * 現小売事業者名称：全角半角混在
     */
    genKoriMeisho?: string;
    /** 
     * 現小売事業者担当者氏名：全角半角混在
     */
    genShimei?: string;
    /** 
     * 現小売事業者担当者連絡先電話番号（市外局番）：電話番号(ハイフンと数値含む)
     */
    genRenrakuTelShigai?: string;
    /** 
     * 現小売事業者担当者連絡先電話番号（市内局番）：電話番号(ハイフンと数値含む)
     */
    genRenrakuTelShinai?: string;
    /** 
     * 現小売事業者担当者連絡先電話番号（加入者番号）：電話番号(ハイフンと数値含む)
     */
    genRenrakuTelKanyusha?: string;
    /** 
     * 契約番号：半角英数混在
     */
    ctrNo?: string;
    /** 
     * 需要者氏名：全角半角混在
     */
    juyoshaShimei?: string;
    /** 
     * 廃止年月日：日付YYYYMMDD
     */
    haishiYmd?: string;
    /** 
     * スイッチング廃止取次ステータス：半角英数混在
     */
    haishiToritsugiStatus?: string;
    /** 
     * スイッチング廃止取次ステータス名称：全角半角混在
     */
    haishiToritsugiStatusMeisho?: string;
    /** 
     * スイッチング廃止取次判断：半角英数混在
     */
    haishiToritsugiHandan?: string;
    /** 
     * スイッチング廃止取次判断名称：全角半角混在
     */
    haishiToritsugiHandanMeisho?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（１）：半角英数混在
     */
    switchingAblcomNgrsn_1?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（１）名称：全角半角混在
     */
    switchingAblcomNgrsn_1Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（２）：半角英数混在
     */
    switchingAblcomNgrsn_2?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（２）名称：全角半角混在
     */
    switchingAblcomNgrsn_2Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（３）：半角英数混在
     */
    switchingAblcomNgrsn_3?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（３）名称：全角半角混在
     */
    switchingAblcomNgrsn_3Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（４）：半角英数混在
     */
    switchingAblcomNgrsn_4?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（４）名称：全角半角混在
     */
    switchingAblcomNgrsn_4Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（５）：半角英数混在
     */
    switchingAblcomNgrsn_5?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（５）名称：全角半角混在
     */
    switchingAblcomNgrsn_5Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（６）：半角英数混在
     */
    switchingAblcomNgrsn_6?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（６）名称：全角半角混在
     */
    switchingAblcomNgrsn_6Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（７）：半角英数混在
     */
    switchingAblcomNgrsn_7?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（７）名称：全角半角混在
     */
    switchingAblcomNgrsn_7Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（８）：半角英数混在
     */
    switchingAblcomNgrsn_8?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（８）名称：全角半角混在
     */
    switchingAblcomNgrsn_8Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（９）：半角英数混在
     */
    switchingAblcomNgrsn_9?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（９）名称：全角半角混在
     */
    switchingAblcomNgrsn_9Aname?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（１０）：半角英数混在
     */
    switchingAblcomNgrsn_10?: string;
    /** 
     * スイッチング廃止取次判断ＮＧ理由（１０）名称：全角半角混在
     */
    switchingAblcomNgrsn_10Aname?: string;
    /** 
     * 接続供給開始年月日：日付YYYYMMDD
     */
    setsuzokuKyokyuKaishiYmd?: string;
    /** 
     * 接続供給廃止年月日：日付YYYYMMDD
     */
    setsuzokuKyokyuHaishiYmd?: string;
    /** 
     * 契約変更年月日：日付YYYYMMDD
     */
    keiyakuHenkoYmd?: string;
    /** 
     * マッチング日設定ステータス：半角英数混在
     */
    matchingdateSetupstatus?: string;
    /** 
     * マッチング日設定ステータス名称：全角半角混在
     */
    matchingdateSetupstatusAname?: string;
    /** 
     * 名義訂正補正ステータス：半角英数混在
     */
    meigicancelHoseistatus?: string;
    /** 
     * 名義訂正補正ステータス名称：全角半角混在
     */
    meigicancelHoseistatusAname?: string;
    /** 
     * 廃止取次有無フラグ：半角英数混在
     */
    ablcomFlg?: string;
    /** 
     * 廃止取次有無フラグ名称：全角半角混在
     */
    ablcomEonflgAname?: string;
    /** 
     * 名義訂正補正エラー理由：全角半角混在
     */
    meigiteiseihoseiErrrsn?: string;
    /** 
     * 名義訂正補正エラー理由名称：全角半角混在
     */
    meigiteiseihoseiErrrsnAname?: string;
}
